"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filterFulfillmentConfigurations = exports.updatedFilteredFulfillmentConfigurations = void 0;

var _actiontypes = _interopRequireDefault(require("./actiontypes"));

/* Basic Actions */
var updatedFilteredFulfillmentConfigurations = function updatedFilteredFulfillmentConfigurations(_ref) {
  var filteredFulfillmentConfigurations = _ref.filteredFulfillmentConfigurations;
  return {
    type: _actiontypes["default"].UPDATED_FILTERED_FULFILLMENT_CONFIGURATIONS,
    filteredFulfillmentConfigurations: filteredFulfillmentConfigurations
  };
};
/* Advanced/Thunk Actions */

/**
 * Populates filteredFulfillmentConfigurations by filtering availableFulfillmentConfigurations
 * @param {string} newFilterString The string to filter the fulfillment configuration names by
 */


exports.updatedFilteredFulfillmentConfigurations = updatedFilteredFulfillmentConfigurations;

var filterFulfillmentConfigurations = function filterFulfillmentConfigurations(_ref2) {
  var newFilterString = _ref2.newFilterString;
  return function (dispatch, getState) {
    var _getState = getState(),
        availableFulfillmentConfigurations = _getState.fulfillmentConfigurationListReducer.availableFulfillmentConfigurations;

    var filteredFulfillmentConfigurations;

    if (newFilterString) {
      filteredFulfillmentConfigurations = availableFulfillmentConfigurations.filter(function (_ref3) {
        var fulfillmentConfigurationName = _ref3.fulfillmentConfigurationName;
        return fulfillmentConfigurationName.toLowerCase().includes(newFilterString.toLowerCase());
      });
    } else {
      filteredFulfillmentConfigurations = availableFulfillmentConfigurations;
    }

    dispatch(updatedFilteredFulfillmentConfigurations({
      filteredFulfillmentConfigurations: filteredFulfillmentConfigurations
    }));
  };
};

exports.filterFulfillmentConfigurations = filterFulfillmentConfigurations;